
import OptionProvince from '../types/OptionProvince';

const argentineProvinces: OptionProvince[] = [
  { value: 'BSA', text: 'Buenos Aires', postal_code_letter: 'B' },
  { value: 'CAB', text: 'CABA', postal_code_letter: 'C' },
  { value: 'CAT', text: 'Catamarca', postal_code_letter: 'K' },
  { value: 'COR', text: 'Córdoba', postal_code_letter: 'X' },
  { value: 'CRR', text: 'Corrientes', postal_code_letter: 'W' },
  { value: 'CHA', text: 'Chaco', postal_code_letter: 'H' },
  { value: 'CHU', text: 'Chubut', postal_code_letter: 'U' },
  { value: 'ENT', text: 'Entre Ríos', postal_code_letter: 'E' },
  { value: 'FOR', text: 'Formosa', postal_code_letter: 'P' },
  { value: 'JUJ', text: 'Jujuy', postal_code_letter: 'Y' },
  { value: 'PAM', text: 'La Pampa', postal_code_letter: 'L' },
  { value: 'RIO', text: 'La Rioja', postal_code_letter: 'F' },
  { value: 'MEN', text: 'Mendoza', postal_code_letter: 'M' },
  { value: 'MIS', text: 'Misiones', postal_code_letter: 'N' },
  { value: 'NEU', text: 'Neuquén', postal_code_letter: 'Q' },
  { value: 'RNE', text: 'Río Negro', postal_code_letter: 'R' },
  { value: 'SAL', text: 'Salta', postal_code_letter: 'A' },
  { value: 'SJU', text: 'San Juan', postal_code_letter: 'J' },
  { value: 'SLU', text: 'San Luis', postal_code_letter: 'D' },
  { value: 'SCR', text: 'Santa Cruz', postal_code_letter: 'Z' },
  { value: 'SFE', text: 'Santa Fe', postal_code_letter: 'S' },
  { value: 'SDE', text: 'Santiago del Estero', postal_code_letter: 'G' },
  { value: 'TDF', text: 'Tierra del Fuego', postal_code_letter: 'V' },
  { value: 'TUC', text: 'Tucumán', postal_code_letter: 'T' },
];

export default argentineProvinces;
